import "./Body/body.scss";
import {
    type FC,
    Suspense,
    useRef,
} from "react";
import { UIScrollProvider } from "#/Utilities/UI/UIScrollContainer.tsx";
import { useShopfrontDispatch, useShopfrontSelector } from "../_Bootstrap/hooks";
import { LAYOUT_BODY_CLICK } from "../Actions/General/LayoutActions";
import { BodyContext } from "../Common/Context/BodyContext";
import LoadingScreen from "../Common/Loading/LoadingScreen";
import { ErrorBoundary } from "../Common/Misc/ErrorBoundary";
import Routes from "../Routes/Routes";
import { fireEventType } from "../Utilities/Generic/ActionsHelper";
import { useShowMenu } from "../Utilities/Hooks/ShowMenu";
import { PrintContext } from "../Utilities/UI/PrintHelper";
import Overlay from "./General/Overlay";

const Body: FC = () => {
    const user = useShopfrontSelector(state => state.user);
    const dialogVisible = useShopfrontSelector(state => state.dialog.visible);
    const dispatch = useShopfrontDispatch();
    const forceMenu = useShowMenu();
    const contentRef = useRef<HTMLDivElement>(null);

    const classes = [];

    if(forceMenu) {
        classes.push("menu-force");
    }

    return (
        <ErrorBoundary>
            <main
                onClick={() => dispatch(fireEventType(LAYOUT_BODY_CLICK))}
                className={classes.join(" ")}
            >
                <UIScrollProvider ref={contentRef}>
                    <BodyContext.Provider value={contentRef}>
                        <PrintContext.Provider value={user.id !== false}>
                            <div
                                id="content"
                                ref={contentRef}
                                inert={dialogVisible}
                            >
                                <Suspense fallback={<LoadingScreen>Loading...</LoadingScreen>}>
                                    <Routes />
                                </Suspense>
                            </div>
                            <div id="media-frame" />
                            <div id="drag-layer" />
                            <Overlay />
                        </PrintContext.Provider>
                    </BodyContext.Provider>
                </UIScrollProvider>
            </main>
        </ErrorBoundary>
    );
};

export default Body;
